/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Coordinates of the structure in Cartesian space relative to the Sun, in metres.
 * 
 * @export
 * @interface GetUniverseStructuresStructureIdPosition
 */
export interface GetUniverseStructuresStructureIdPosition {
    /**
     * x number
     * @type {number}
     * @memberof GetUniverseStructuresStructureIdPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof GetUniverseStructuresStructureIdPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof GetUniverseStructuresStructureIdPosition
     */
    z: number;
}

/**
 * Check if a given object implements the GetUniverseStructuresStructureIdPosition interface.
 */
export function instanceOfGetUniverseStructuresStructureIdPosition(value: object): value is GetUniverseStructuresStructureIdPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function GetUniverseStructuresStructureIdPositionFromJSON(json: any): GetUniverseStructuresStructureIdPosition {
    return GetUniverseStructuresStructureIdPositionFromJSONTyped(json, false);
}

export function GetUniverseStructuresStructureIdPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStructuresStructureIdPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function GetUniverseStructuresStructureIdPositionToJSON(json: any): GetUniverseStructuresStructureIdPosition {
    return GetUniverseStructuresStructureIdPositionToJSONTyped(json, false);
}

export function GetUniverseStructuresStructureIdPositionToJSONTyped(value?: GetUniverseStructuresStructureIdPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

